import { Spinner } from "@heroui/react";
import { useUpdateAdmissionsAuction } from "apollo/hooks/mutations";
import { isLoading } from "apollo/utils";
import { getStaticAsset } from "core/model/config";
import { usePageMetaData } from "dsl/hooks";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslations } from "translations";
import { ActionScreen } from ".";

export function StopAuctionProgress() {
  const translations = useTranslations();
  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <Spinner
        aria-valuemax={100}
        aria-valuemin={0}
        aria-valuetext={translations.general.loading}
        role="progressbar"
        size="lg"
      />
    </div>
  );
}

export function StopAuctionFailed() {
  const translations = useTranslations();
  usePageMetaData({
    title: () =>
      translations.careproviderApp.recareAdmissionsForm.pageTitles
        .pageWithdrawRequestError,
  });
  return (
    <ActionScreen
      image={getStaticAsset("admissions-error-illustration.svg")}
      imageAlt={
        translations.careproviderApp.recareAdmissionsForm.requetsWitdrawn
          .errorAltTextImage
      }
      paragraphOne={
        translations.careproviderApp.recareAdmissionsForm.requetsWitdrawn
          .errorDescription
      }
      title={
        translations.careproviderApp.recareAdmissionsForm.requetsWitdrawn
          .errorTitle
      }
    />
  );
}

export function StopAuctionSuccess() {
  const translations = useTranslations();
  usePageMetaData({
    title: () =>
      translations.careproviderApp.recareAdmissionsForm.pageTitles
        .pageWithdrawRequestSuccess,
  });
  return (
    <ActionScreen
      image={getStaticAsset("admissions-success-illustration.svg")}
      imageAlt={
        translations.careproviderApp.recareAdmissionsForm.requetsWitdrawn
          .successAltTextImage
      }
      paragraphOne={
        translations.careproviderApp.recareAdmissionsForm.requetsWitdrawn
          .successDescription
      }
      title={
        translations.careproviderApp.recareAdmissionsForm.requetsWitdrawn
          .successTitle
      }
    />
  );
}

export function StopAuction() {
  const [searchParams] = useSearchParams();
  const admissionsToken = searchParams.get("admissions_token");

  const [
    updateAdmissionsAuction,
    updateAdmissionsAuctionProgress,
    _resetProgress,
    _data,
    error,
  ] = useUpdateAdmissionsAuction();

  useEffect(() => {
    if (admissionsToken) {
      updateAdmissionsAuction(admissionsToken);
    }
  }, [admissionsToken, updateAdmissionsAuction]);

  if (isLoading(updateAdmissionsAuctionProgress)) {
    return <StopAuctionProgress />;
  }

  if (!admissionsToken || error) {
    return <StopAuctionFailed />;
  }

  return <StopAuctionSuccess />;
}
